/** Loading, error and empty states — the screens nobody designs and everybody sees. */

import { el } from '../lib/dom';

export function spinner(label = 'Working'): HTMLElement {
  return el(
    'div',
    { class: 'spinner', role: 'status', 'aria-live': 'polite' },
    el('span', { class: 'visually-hidden', text: label }),
  );
}

export interface ErrorScreenOptions {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
}

export function errorScreen(options: ErrorScreenOptions): HTMLElement {
  return el(
    'main',
    { class: 'screen screen--centered' },
    el('h1', { class: 'screen__title', text: options.title }),
    el('p', { class: 'screen__body', text: options.body }),
    el(
      'div',
      { class: 'screen__actions' },
      options.actionLabel &&
        el(
          'button',
          {
            class: 'button button--primary',
            type: 'button',
            onclick: () => options.onAction?.(),
          },
          options.actionLabel,
        ),
      options.secondaryLabel &&
        el(
          'button',
          {
            class: 'button button--ghost',
            type: 'button',
            onclick: () => options.onSecondary?.(),
          },
          options.secondaryLabel,
        ),
    ),
  );
}

/**
 * A short-lived message under a button ("Link copied"). Announced politely so it is not lost
 * on a screen reader, and never blocks anything.
 */
export function toast(container: HTMLElement, message: string, durationMs = 2400): void {
  const existing = container.querySelector('.toast');
  existing?.remove();

  const node = el('p', { class: 'toast', role: 'status', 'aria-live': 'polite', text: message });
  container.appendChild(node);

  window.setTimeout(() => {
    node.classList.add('toast--leaving');
    window.setTimeout(() => node.remove(), 200);
  }, durationMs);
}
